import { render, staticRenderFns } from "./TabletBenefitsSection.vue?vue&type=template&id=dec36e06&scoped=true"
import script from "./TabletBenefitsSection.vue?vue&type=script&lang=js"
export * from "./TabletBenefitsSection.vue?vue&type=script&lang=js"
import style0 from "./TabletBenefitsSection.vue?vue&type=style&index=0&id=dec36e06&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dec36e06",
  null
  
)

export default component.exports